export const WEB_STORAGE_NAMES = {
  UserInfo: "UserInfo",
  StoresList: "StoresList",
  CartItems: "CartItems",
  OrderNumber: "OrderNumber"
};
